import { useTranslation } from 'react-i18next';
import { CookieBanner, type CookieConsent } from '@teivor/shared-ui';

async function persistRemote(consent: CookieConsent): Promise<void> {
  try {
    await fetch('/api/shell/consent', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ category: 'cookie_consent', payload: consent }),
    });
  } catch {
    // Server unreachable — localStorage is source of truth.
  }
}

export function AppCookieBanner() {
  const { t } = useTranslation();
  return (
    <CookieBanner
      onConsent={persistRemote}
      texts={{
        title: t('cookie.banner_title'),
        body: t('cookie.banner_body'),
        acceptAll: t('cookie.accept_all'),
        rejectNonEssential: t('cookie.reject_non_essential'),
        customize: t('cookie.customize'),
        save: t('cookie.save'),
        essentialLabel: t('cookie.essential_label'),
        essentialDesc: t('cookie.essential_desc'),
        analyticsLabel: t('cookie.analytics_label'),
        analyticsDesc: t('cookie.analytics_desc'),
        marketingLabel: t('cookie.marketing_label'),
        marketingDesc: t('cookie.marketing_desc'),
      }}
    />
  );
}
